module.exports = __webpack_public_path__ + "static/media/6_MegaTrend_Infographic.69ab983a.png";